import universal from 'react-universal-component';
import { ghost } from '@minerva-analytics/pantheon';
import { GHOST_API } from './constants';

const AsyncLandingPage = universal(import(`./views/LandingPage`));
const AsyncConfirmPage = universal(import(`./views/ConfirmPage`));
const AsyncLegal = universal(import(`./views/Legal`));
const AsyncThanks = universal(import(`./views/ReengagementThanks`));
const AsyncAbout = universal(import(`./views/About`));
const AsyncArticles = universal(import('./views/Articles'));
const AsyncArticle = universal(import(`./views/Article`));
const AsyncNewsletterPreview = universal(import(`./views/NewsletterPreview`));

const { getArticle, selectArticle } = ghost.actions;
const routes = [
  {
    component: AsyncLandingPage,
    key: `landing`,
    path: `/`,
    exact: true,
  },
  {
    component: AsyncArticles,
    key: `articles`,
    path: `/articles`,
    exact: true,
  },
  {
    component: AsyncConfirmPage,
    key: `landing`,
    path: `/confirm/:id/:token`,
  },
  {
    component: AsyncLegal,
    key: `terms`,
    path: `/terms`,
  },
  {
    component: AsyncLegal,
    key: `privacy`,
    path: `/privacy`,
  },
  {
    component: AsyncLegal,
    key: `cookie`,
    path: `/cookie`,
  },
  {
    component: AsyncLegal,
    key: `ccpa`,
    path: `/ccpa`,
  },
  {
    component: AsyncThanks,
    key: `reengagement-thanks`,
    path: `/respawn`,
  },
  {
    component: AsyncAbout,
    key: `about`,
    path: `/about`,
  },
  {
    component: AsyncArticle,
    key: `/articles/:slug`,
    path: `/articles/:slug`,
    loadData: async (store, match) => {
      const { slug } = match.params;
      store.dispatch(selectArticle(slug));
      await store.dispatch(getArticle(GHOST_API, slug));
    },
  },
  {
    component: AsyncNewsletterPreview,
    key: `newsletterpreview`,
    path: `/newsletterpreview`,
  }
];

export default routes;
